import React, { Fragment, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import Select from "react-select";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import ArticleIcon from "@mui/icons-material/Article";

import {
    getCustomerKeyValuePair,
    getSalePersonDetailKeyValuePair,
    getTermsConditionKeyValue,
    getWarehouseKeyValueDetailsList,
    getInterStateTaxKeyValueList,
    getIntraStateTaxKeyValueList,
    ItemListByWarePrice1,
    getCustomerDetails,
    getSalesOrderDetail,
    getInvoiceDetailsByUUID,
    addSalesOrder,
    updateSalesOrder,
    addDirectInvoiceRecord1,
    addInvoice,
    updateInvoice,
    updatePrice,
} from "../../../services/index";
import { Modal, Spinner } from "react-bootstrap";
import Button from "@mui/material/Button";
import { updateSalesOrderItemByPriceListUid } from "../../../services/Sales/SalesOrderService";
import { getKeyValueList } from "../../../services/Purchase/TcsService";
import { Input } from "antd";

const defaultTcsObj = {
    tcsRate: 0,
    tcsRateAmount: 0
}

const eWayBillOptionsObj = [
    {
        label: "Regular",
        value: "Regular"
    },
    {
        label: "Bill To Ship To",
        value: "BillShipTo"
    },
    // {
    //     label: "Bill Dispatch From",
    //     value: "BillDispatchFrom"
    // },
    // {
    //     label: "Combination Of Bill To And Bill From",
    //     value: "CombinationOfBillToAndBillFrom"
    // },
]

const InvoiceNew = ({ type }) => {
    let { id } = useParams();
    const location = useLocation();
    let orgDetail = JSON.parse(localStorage.getItem("orgDetail"));
    let OrgState = orgDetail?.beanAddress?.state;
    let directInvoice = location?.state?.directInvoice;
    let invoiceOrder = location?.state?.invoiceOrder;
    let invoiceId = location?.state?.invoiceId;
    let invoiceEdit = location?.state?.invoiceEdit;
    let reInvoice = location?.state?.reInvoice;
    const [title, setTitle] = useState("");
    const [itemLoading, setItemLoading] = useState(false);
    useEffect(() => {
        if (directInvoice) {
            setTitle("DIRECT INVOICE");
        }
        if (id) {
            setTitle("EDIT SALES ORDER");
        }
        if (invoiceId && invoiceOrder) {
            setTitle("NEW INVOICE");
        }
        if (invoiceId && invoiceEdit && reInvoice) {
            setTitle("RE INVOICE");
        } else if (invoiceId && invoiceEdit) {
            setTitle("EDIT INVOICE");
        }
        if (!id && !invoiceEdit && !directInvoice && !invoiceOrder && !reInvoice) {
            setTitle("NEW SALES");
        }
    }, [location?.state]);

    let navigate = useNavigate();
    var curr = new Date();
    curr.setDate(curr.getDate());
    var date1 = curr.toISOString()?.substring(0, 10);

    const [loading, setLoading] = useState(false);
    const [salesInfo, setSalesInfo] = useState({
        customer: "",
        warehouse: "",
        salesPerson: "",
        taxType: "",
        reference: "",
        orderDate: date1,
        orgDetail: "",
        shipDate: date1,
        invoiceDate: date1,
        notes: "",
        terms: "",
        subTotal: 0.0,
        total: 0.0,
        shipCharge: "",
        netShip: 0.0,
        netTax: 0,
        shipTax: "",
        isTcsApplied: false,
        tcsRate: 0,
        tcsRateAmount: 0,
        motorVehicleNo: "",
        eWayBillTransactionEnum: {
            label: "Regular",
            value: "Regular"
        }
    });

    const tempRows = {
        item: {
            value: "",
            label: "",
        },
        quantity: 1,
        taxBean: "",
        rate: 0,
        amount: 0,
        isFloating: false,
        itemTitle: "",
        itemUuid: "",
        deleted: false,
        oldItemRemoveNewItemAdd: true,
        beanStockTransferBatchList: [{
            stockTransferId: '',
            stockTransferNo: '',
            batchQuantitySelected: '',
            batchNumber: '',
            batchManufacturingDate: null,
            batchExpiredDate: null,
            storeTitle: '',
            rackTitle: '',
            cellTitle: '',
            palletTitle: '',
            storeId: '',
            rackId: '',
            cellId: '',
            palletId: '',
            rackOptions: [],
            cellOptions: [],
            palleteOptions: [],
            referenceTitle: ""
        }],
        beanInvoiceBatchesList: []
    };

    const [rows, setRows] = useState([tempRows]);
    const [disableWhileEditing, setdisablewhileEditing] = useState([])
    const [wareOptions, setWareOptions] = useState("");
    const [customerOptions, setCustomerOptions] = useState("");
    const [salesPerOptions, setSalesPerOptions] = useState("");
    const [termsOptions, setTermsOptions] = useState("");
    const [itemOptions, setItemOptions] = useState("");
    const [itemOptions2, setItemOptions2] = useState("");
    const [taxOptions, setTaxOptions] = useState("");
    const [show, setShow] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [defaultTcs, setDefaultTcs] = useState(defaultTcsObj)
    const [fssaiWarningStatus, setFssaiWarningStatus] = useState(null);
    const [showFssaiModal, setShowFssaiModal] = useState(false);
    const [customFields, setCustomFields] = useState([]);

    const handleAddCustomField = () => {
        setCustomFields([...customFields, { label: "", value: "" }]);
    };

    const handleRemoveCustomField = (index) => {
        setCustomFields(customFields.filter((_, i) => i !== index));
    };

    const handleCustomFieldChange = (index, field, val) => {
        const updated = [...customFields];
        updated[index][field] = val;
        setCustomFields(updated);
    };

    useEffect(() => {
        if (fssaiWarningStatus?.status === "EXPIRED" || fssaiWarningStatus?.status === "DUE") {
            setShowFssaiModal(true);
        } else {
            setShowFssaiModal(false);
        }
    }, [fssaiWarningStatus]);

    useEffect(() => {
        callBasicAPI();
        if (type === "new") {
            getTcsValue();
        }
        if (id) {
            getSalesOrderDetails(id);
        }
        if (invoiceId && invoiceEdit) {
            getInvoiceDetails(invoiceId);
        }

        if (invoiceId && invoiceOrder) {
            getSalesOrderDetails(invoiceId);
        }
    }, []);

    const getTcsValue = () => {
        getKeyValueList().then((response) => {
            setDefaultTcs({
                ...defaultTcs,
                tcsRate: parseFloat(response.responsePacket[0].value)
            });
            if (salesInfo.isTcsApplied) {
                setSalesInfo({
                    ...salesInfo,
                    tcsRate: parseFloat(response.responsePacket[0].value)
                })
            }
        }).catch((err) => {
            console.error("err :: ", err.message);
        })
    }

    const getInvoiceDetails = (invoiceId) => {
        getInvoiceDetailsByUUID(invoiceId)
            .then((res) => {
                if (res.errorCode === 0) {
                    handleForm(res, invoiceEdit);
                }
            })
            .catch(() => {
                toast.error("server error in invoiceUUID");
                return;
            });
    };

    const getSalesOrderDetails = (Id) => {
        getSalesOrderDetail(Id)
            .then((res) => {
                handleForm(res);
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };
    const handleForm = (res, invoiceEdit) => {
        if (res.errorCode === 0) {
            let taxTypeCheck = "";
            let d = res.responsePacket;
            let itemList;
            if (invoiceEdit) {
                itemList = res.responsePacket.itemsList;
            } else {
                itemList = res.responsePacket.items;
            }

            let wId = d.warehouseId;
            let pId = d.priceListId;
            let edit = true;

            d.customerAddresses?.map((a) => {
                if (a.addressType === "Billing") {
                    d.billAdd = a;
                }

                if (a.addressType === "Shipping") {
                    d.shipAdd = a;
                }
            });

            if (!d.billAdd?.pinCode || d.billAdd?.pinCode === "123456") {
                toast.error("Improper Customer's pinCode ");
            }
            if (!d.shipAdd?.pinCode || d.shipAdd?.pinCode === "123456") {
                toast.error("Improper Customer's pinCode ");
            }
            if (!d.shipAdd?.city || !d.billAdd?.city) {
                toast.error("Improper Customer's City ");
            }
            if (!d.shipAdd?.addressLine2 || !d.billAdd?.addressLine2) {
                toast.error("Improper Customer's addressLine2 ");
            }

            getCustomerDetails(d.customerId).then((res) => {
                if (res.errorCode === 0) {
                    let a1 = res.responsePacket;
                    let customer = {
                        recordId: d.customerId,
                        title: d.customerTitle,
                        value: d.customerId,
                        label: d.customerTitle,
                        billAdd: d.billAdd,
                        shipAdd: d.shipAdd,
                        phone: d.phone,
                        itemPriceListTitle: d.priceListTitle,
                        itemPriceListRecordId: d.priceListId,
                        discountValue: a1?.discountValue ? a1?.discountValue : 0,
                        discountType: a1?.discountType,
                        paymentTermRecordId: d.paymentTermsId,
                        paymentTermTitle: d.paymentTermsTitle,
                    };

                    let fssaiEnum = a1.fssaiEnum;
                    let fssaiDate = a1.fssaiValidateDate;
                    setFssaiWarningStatus({status: fssaiEnum, date: fssaiDate});
                    let netTax = 0;
                    let sub1 = 0;
                    itemList?.map((a) => {
                        sub1 = sub1 + a.amount;
                    });

                    if (Number(sub1).toFixed(2) !== Number(d.subTotalAmount).toFixed(2)) {
                        toast.error("subtotal mismatch");
                    }

                    itemList?.map((c) => {
                        c.taxBean.amount = c.amount * 0.01 * c.taxBean.rate;
                        netTax += c.taxBean.amount;
                    });
                    d.totalAmount = d.subTotalAmount + netTax + d.shippingCharges;

                    let warehouse = { value: d.warehouseId, label: d.warehouseTitle };
                    let terms = { value: d.termsConditionId, label: d.termsCondition };
                    let salesPerson = {
                        value: d.salespersonId,
                        label: d.salespersonTitle,
                    };
                    let eWayBillTransactionEnum = {
                        label: d.ewayBillTransactionEnum,
                        value: d.ewayBillTransactionEnum
                    }
                    let shipTax = {
                        value: d.shippingChargeTaxId,
                        label: d.shippingChargeTaxTitle,
                        rate: d.shippingChargeTaxRate,
                    };

                    // note:  d.shippingCharges=netShip
                    // so we need to calculate shipCharge i.e without tax

                    let shipCharge = d.shippingCharges / (1 + d.shippingChargeTaxRate * 0.01);
                    let custGst12 = d.customerGstNumber?.substring(0, 2);
                    let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);
                    let customerAddress;
                    d.customerAddresses.map((item) => {
                        if (item.addressType === "Billing") {
                            customerAddress = item.state;
                        }
                    })



                    if (custGst12 === orgGst12) {
                        taxTypeCheck = true;
                        handleGetItems(wId, pId, d.customerId, edit, "Intra", itemList);
                        getIntraStateTaxKeyValueList().then((res) => {
                            let d = res.responsePacket;
                            const options = d?.map((a) => ({
                                label: a.title,
                                value: a.recordId,
                                rate: a.rate,
                                taxType: a.taxType,
                            }));
                            setTaxOptions(options);
                        });
                    } else {
                        if (customerAddress === OrgState) {
                            taxTypeCheck = true;
                            handleGetItems(wId, pId, d.customerId, edit, "Intra", itemList);
                            getIntraStateTaxKeyValueList().then((res) => {
                                let d = res.responsePacket;
                                const options = d?.map((a) => ({
                                    label: a.title,
                                    value: a.recordId,
                                    rate: a.rate,
                                    taxType: a.taxType,
                                }));
                                setTaxOptions(options);
                            });
                        } else {
                            taxTypeCheck = false;
                            handleGetItems(wId, pId, d.customerId, edit, "Inter", itemList);
                            getInterStateTaxKeyValueList().then((res) => {
                                let d = res.responsePacket;
                                const options = d?.map((a) => ({
                                    label: a.title,
                                    value: a.recordId,
                                    rate: a.rate,
                                    taxType: a.taxType,
                                }));
                                setTaxOptions(options);
                            });
                        }
                    }

                    if (type !== "new") {
                        setDefaultTcs((prev) => ({
                            ...prev,
                            tcsRate: d?.tcsRate,
                            tcsRateAmount: d?.tcsRateAmount
                        }));
                    }


                    setSalesInfo({
                        ...salesInfo,
                        customer: customer,
                        warehouse: warehouse,
                        salesPerson: salesPerson,
                        eWayBillTransactionEnum: eWayBillTransactionEnum,
                        terms: terms,
                        shipTax: shipTax,
                        shipCharge: Number(shipCharge.toFixed(2)),
                        netTax: netTax,

                        isTcsApplied: type === "new" ? salesInfo.isTcsApplied : d?.isTcsApplied,
                        tcsRate: type === "new" ? salesInfo.tcsRate : d?.isTcsApplied ? d?.tcsRate : 0,
                        tcsRateAmount: type === "new" ? (d?.totalAmount * (salesInfo.tcsRate / 100)) : d?.isTcsApplied ? d?.tcsRateAmount : 0,

                        reference: d.referenceNo,
                        orderDate: d.salesOrderDate,
                        shipDate: d.expectedShipmentDate,
                        notes: d.customerNote,
                        subTotal: d.subTotalAmount,
                        total: type === "new" ? (d?.totalAmount + (d?.totalAmount * ((salesInfo.tcsRate) / 100))) : d?.isTcsApplied ? (d?.totalAmount + (d?.totalAmount * ((d?.tcsRate) / 100))) : d?.totalAmount,
                        netShip: d.shippingCharges,

                        orderNo: d?.orderNo || d?.salesOrderNo,
                        salesOrderId: invoiceEdit ? d.salesOrderId : d?.recordId,
                        taxType: taxTypeCheck ? "Intra" : "Inter",

                        motorVehicleNo: d?.motorVehicleNo,
                        invoiceDate: d?.invoiceDate ? d?.invoiceDate : date1,
                        invoiceNo: d?.invoiceNo,
                        recordId: d?.recordId,

                    });

                    // Load custom metadata fields
                    if (d?.metaData) {
                        try {
                            const parsed = JSON.parse(d.metaData);
                            if (Array.isArray(parsed)) {
                                setCustomFields(parsed);
                            }
                        } catch (e) {
                            console.error("Error parsing metaData", e);
                        }
                    }
                }
            });
        } else {
            toast(res.message);
        }
    };

    const handleGetItems = (wId, pId, customerId, edit, editTaxType, itemList) => {
        setItemLoading(true);
        ItemListByWarePrice1(wId, pId, customerId)
            .then((res) => {
                let netTaxType;
                if (edit) {
                    netTaxType = editTaxType;
                } else {
                    netTaxType = salesInfo.taxType;
                }
                if (res.errorCode === 0) {
                    let d = res.responsePacket
                    const options = d?.map((a) => ({
                        value: a.title,
                        // label:a.title,
                        label: (
                            <>
                                <div>{a.title}</div>
                                <div className="row2">
                                    <span style={{ color: a.currentStockQuantity <= 0 ? "red" : "" }}>
                                        Available Stock: {a.currentStockQuantity?.toFixed(2)}&nbsp;&nbsp;
                                        {a?.selectedUnitInPriceList}{" "}
                                    </span>{" "}
                                    <span>Rate: {a.sellingPriceValue}</span>
                                </div>
                            </>
                        ),
                        stock: a.currentStockQuantity?.toFixed(2),
                        itemId: a.recordId,
                        title: a.title,
                        taxBean: netTaxType === "Inter" ? a.interstateTax : a.intrastateTax,
                        isFloating: a.isFloating,
                        rate: a.sellingPriceValue,
                        unit: a?.selectedUnitInPriceList,
                        unitId: a.packUnitTitle === a?.selectedUnitInPriceList ? a.packUnitId : a.itemUnitId,
                        beanInvoiceBatchesList: a?.beanInvoiceBatchesList,
                        beanStockTransferBatchList: a?.beanStockTransferBatchList || [{
                            stockTransferId: '',
                            stockTransferNo: '',
                            batchQuantitySelected: '',
                            batchNumber: '',
                            batchManufacturingDate: null,
                            batchExpiredDate: null,
                            storeTitle: '',
                            rackTitle: '',
                            cellTitle: '',
                            palletTitle: '',
                            storeId: '',
                            rackId: '',
                            cellId: '',
                            palletId: '',
                            rackOptions: [],
                            cellOptions: [],
                            palleteOptions: [],
                            referenceTitle: ""
                        }]
                    }));
                    if (itemList) {
                        let tempRows = [];
                        let subT = 0;
                        options?.map((a1) => {
                            itemList?.map((c) => {
                                if (a1.itemId === c.itemUuid) {
                                    let obj = {
                                        item: {
                                            label: c.itemTitle,
                                            value: c.itemUuid,
                                        },
                                        stock: a1.stock,
                                        itemUuid: c.itemUuid,
                                        itemTitle: c.itemTitle,
                                        isFloating: c?.isFloating,
                                        amount: c.amount,
                                        quantity: c.quantity,
                                        taxBean: c.taxBean,
                                        rate: c.rate,
                                        hsnSac: c.hsnSac,
                                        hsnUuid: c.hsnUuid,
                                        unit: c?.unit,
                                        unitId: c?.unitId,
                                        beanInvoiceBatchesList: c?.beanInvoiceBatchesList || [],
                                        beanStockTransferBatchList: c?.beanStockTransferBatchList || [{
                                            stockTransferId: '',
                                            stockTransferNo: '',
                                            batchQuantitySelected: '',
                                            batchNumber: '',
                                            batchManufacturingDate: null,
                                            batchExpiredDate: null,
                                            storeTitle: '',
                                            rackTitle: '',
                                            cellTitle: '',
                                            palletTitle: '',
                                            storeId: '',
                                            rackId: '',
                                            cellId: '',
                                            palletId: '',
                                            rackOptions: [],
                                            cellOptions: [],
                                            palleteOptions: [],
                                            referenceTitle: "",

                                        }]
                                    };
                                    tempRows.push(obj);
                                }
                            });
                        });
                        setdisablewhileEditing(tempRows)
                        setRows(tempRows);
                    }
                    setItemLoading(false);
                    setItemOptions(options);
                    setItemOptions2(options);
                } else {
                    handleToast(res);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleAddNewRow = () => {
        setRows([...rows, tempRows]);
        handleFilterItems(rows);
    };

    const handleToast = (res) => {
        toast(res.message);
    };

    const callBasicAPI = () => {
        getCustomerKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                    tcsApplicable: d.tcsApplicable
                }));
                setCustomerOptions(options);
            } else {
                handleToast(res);
            }
        });

        getWarehouseKeyValueDetailsList().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setWareOptions(options);
            } else {
                handleToast(res);
            }
        });

        getTermsConditionKeyValue().then((res) => {
            if (res.errorCode === 0) {
                const options = res.responsePacket?.map((d) => ({
                    value: d.key,
                    label: d.value,
                }));
                setSalesInfo({
                    ...salesInfo,
                    terms: options[0],
                });
                setTermsOptions(options);
            } else {
                handleToast(res);
            }
        });
        getSalesKeyValue();
    };
    const getSalesKeyValue = () => {
        getSalePersonDetailKeyValuePair().then((res) => {
            if (res.errorCode === 0) {
                const data = res.responsePacket;
                const options = data?.map((d) => ({
                    value: d.key,
                    label: d.value,
                    email: d.value2,
                }));

                setSalesPerOptions(options);
            } else {
                handleToast(res);
            }
        });
    };

    const freshCustomer = (aa, d1, taxType, e) => {
        setItemOptions("");
        setItemOptions2("");
        setRows([tempRows]);
        if (e.tcsApplicable) {
            getKeyValueList().then((response) => {
                setDefaultTcs({
                    ...defaultTcs,
                    tcsRate: parseFloat(response.responsePacket[0].value),
                    tcsRateAmount: 0,
                });
                setSalesInfo({
                    ...salesInfo,
                    taxType: taxType,
                    customer: d1,
                    warehouse: "",
                    shipTax: aa[0],
                    netTax: 0,
                    subTotal: 0,
                    netShip: 0,
                    isTcsApplied: true,
                    tcsRate: parseFloat(response.responsePacket[0].value),
                    tcsRateAmount: 0,
                    shipCharge: 0,
                    total: 0,
                });
            }).catch((err) => {
                console.error("err :: ", err.message);
            })
        } else {
            setDefaultTcs({
                ...defaultTcs,
                tcsRateAmount: 0
            })
            setSalesInfo({
                ...salesInfo,
                taxType: taxType,
                customer: d1,
                warehouse: "",
                shipTax: aa[0],
                netTax: 0,
                subTotal: 0,
                netShip: 0,
                isTcsApplied: false,
                tcsRate: 0,
                tcsRateAmount: 0,
                shipCharge: 0,
                total: 0,
            });
        }
    };

    const freshWare = (e) => {
        setItemOptions("");
        setItemOptions2("");
        setRows([tempRows]);
        if (e.tcsApplicable) {
            getKeyValueList().then((response) => {
                setDefaultTcs({
                    ...defaultTcs,
                    tcsRate: parseFloat(response.responsePacket[0].value),
                    tcsRateAmount: 0,
                });
                setSalesInfo({
                    ...salesInfo,
                    warehouse: e,
                    netTax: 0,
                    subTotal: 0,
                    netShip: 0,
                    isTcsApplied: true,
                    tcsRate: parseFloat(response.responsePacket[0].value),
                    tcsRateAmount: 0,
                    shipCharge: 0,
                    total: 0,
                });
            }).catch((err) => {
                console.error("err :: ", err.message);
            })
        } else {
            setDefaultTcs({
                ...defaultTcs,
                tcsRateAmount: 0
            })
            setSalesInfo({
                ...salesInfo,
                warehouse: e,
                netTax: 0,
                subTotal: 0,
                netShip: 0,
                isTcsApplied: false,
                tcsRate: 0,
                tcsRateAmount: 0,
                shipCharge: 0,
                total: 0,
            });
        }
    }

    const handleCustomer = (e) => {
        getCustomerDetails(e.value)
            .then((res) => {
                if (res.errorCode === 0) {
                    let d1 = res.responsePacket;
                    d1.value = d1.recordId;
                    d1.label = d1.title;

                    d1.addressList?.map((a) => {
                        if (a.addressType === "Billing") {
                            d1.billAdd = a;
                        }

                        if (a.addressType === "Shipping") {
                            d1.shipAdd = a;
                        }
                    });

                    if (!d1.billAdd?.pinCode || d1.billAdd?.pinCode === "123456") {
                        toast.error("Improper Customer's pinCode ");
                    }
                    if (!d1.shipAdd?.pinCode || d1.shipAdd?.pinCode === "123456") {
                        toast.error("Improper Customer's pinCode ");
                    }
                    if (!d1.shipAdd?.city || !d1.billAdd?.city) {
                        toast.error("Improper Customer's City ");
                    }
                    if (!d1.shipAdd?.addressLine2 || !d1.billAdd?.addressLine2) {
                        toast.error("Improper Customer's addressLine2 ");
                    }

                    let custGst12 = d1.gstNumber?.substring(0, 2);
                    let orgGst12 = orgDetail?.gstNumber?.substring(0, 2);

                    let fssaiEnum = d1.fssaiEnum;
                    let fssaiDate = d1.fssaiValidateDate;
                    setFssaiWarningStatus({status: fssaiEnum, date: fssaiDate});

                    let customerAddress;
                    d1.addressList.map((item) => {
                        if (item.addressType === "Billing") {
                            customerAddress = item.state;
                        }
                    })

                    if (custGst12 === orgGst12) {
                        getIntraStateTaxKeyValueList().then((res) => {
                            let d = res.responsePacket;
                            const options = d?.map((a) => ({
                                label: a.title,
                                value: a.recordId,
                                rate: a.rate,
                                taxType: a.taxType,
                            }));
                            setTaxOptions(options);
                            const aa = options.filter((c) => c.taxType === "GST" && c.rate === 18.0);
                            freshCustomer(aa, d1, "Intra", e);
                        });
                    } else {
                        if (customerAddress === OrgState) {
                            getIntraStateTaxKeyValueList().then((res) => {
                                let d = res.responsePacket;
                                const options = d?.map((a) => ({
                                    label: a.title,
                                    value: a.recordId,
                                    rate: a.rate,
                                    taxType: a.taxType,
                                }));
                                setTaxOptions(options);
                                const aa = options.filter((c) => c.taxType === "GST" && c.rate === 18.0);
                                freshCustomer(aa, d1, "Intra", e);
                            });
                        } else {
                            getInterStateTaxKeyValueList().then((res) => {
                                let d = res.responsePacket;
                                const options = d?.map((a) => ({
                                    label: a.title,
                                    value: a.recordId,
                                    rate: a.rate,
                                    taxType: a.taxType,
                                }));
                                setTaxOptions(options);
                                const aa = options.filter((c) => c.taxType === "IGST" && c.rate === 18.0);
                                freshCustomer(aa, d1, "Inter", e);
                            });
                        }
                    }
                } else {
                    handleToast(res);
                }
            })
            .catch(() => {
                toast.error("server error");
                return;
            });
    };

    const handleWarehouse = (e) => {
        setSalesInfo({ ...salesInfo, warehouse: e });
        let pId = salesInfo.customer.itemPriceListRecordId;
        let wId = e.value;
        let customerId = salesInfo.customer.recordId;
        handleGetItems(wId, pId, customerId);
        freshWare(e);
    };

    const handleData = (e, key) => {
        setSalesInfo({
            ...salesInfo,
            [e.target.name]: e.target.value,
        });
    };

    const handleTerms = (e) => {
        setSalesInfo({
            ...salesInfo,
            terms: e,
        });
    };

    const handleItem = (e, i) => {
        const obj = [...rows];
        obj[i].item.value = e.itemId;
        obj[i].item.label = e.title;
        obj[i].rate = e.rate;
        obj[i].isFloating = e.isFloating;
        obj[i].stock = e.stock;
        obj[i].itemUuid = e.itemId;
        obj[i].itemTitle = e.title;
        obj[i].taxBean = e.taxBean;
        obj[i].amount = e.rate * obj[i].quantity;
        obj[i].taxBean.amount1 = obj[i].amount * e.taxBean.rate * 0.01;
        obj[i].unit = e.unit;
        obj[i].unitId = e.unitId;
        obj[i].beanInvoiceBatchesList = e?.beanInvoiceBatchesList;
        obj[i].beanStockTransferBatchList = [{
            stockTransferId: '',
            stockTransferNo: '',
            batchQuantitySelected: '',
            batchNumber: '',
            batchManufacturingDate: null,
            batchExpiredDate: null,
            storeTitle: '',
            rackTitle: '',
            cellTitle: '',
            palletTitle: '',
            storeId: '',
            rackId: '',
            cellId: '',
            palletId: '',
            rackOptions: [],
            cellOptions: [],
            palleteOptions: [],
            referenceTitle: ""
        }]
        obj[i].taxBean.amount = obj[i].taxBean.amount1;

        setRows(obj);
        handleSubTotal(obj);
        handleFilterItems(obj);
    };

    const handleFilterItems = (rows) => {
        var send = false;
        var filterOptions = [];
        itemOptions2 &&
            itemOptions2?.map((a) => {
                rows &&
                    rows?.map((b) => {
                        if (a.itemId === b?.item?.value) {
                            send = true;
                        }
                    });
                if (!send) {
                    filterOptions.push(a);
                }
                send = false;
            });
        setItemOptions(filterOptions);
    };
    const handleClear = (id, i) => {
        const obj = rows.slice();
        obj.splice(i, 1);
        setRows(obj);
        handleFilterItems(obj);
        handleSubTotal(obj);
    };

    const handleSubTotal = (rows) => {
        let sum2 = 0;
        let netTax = 0;
        let netShip = salesInfo.netShip;
        let tcsAmt = 0;

        let rows2 = rows.filter((a) => a.item.value !== "");

        rows2?.map((data) => {
            sum2 += data.amount;
            netTax += data.taxBean.amount;
        });

        let sum3 = sum2 + netTax + netShip;

        tcsAmt = sum3 * defaultTcs.tcsRate / 100;
        setDefaultTcs((prev) => ({
            ...prev,
            tcsRateAmount: tcsAmt
        }))

        if (salesInfo.isTcsApplied) {
            sum3 = sum3 + tcsAmt;
        } else {
            tcsAmt = 0;
        }

        setSalesInfo({
            ...salesInfo,
            netTax: netTax,
            netShip: netShip,
            subTotal: sum2.toFixed(2),
            tcsRateAmount: tcsAmt,
            total: sum3.toFixed(2),
            discountRate: 0,
        });
    };

    const handlequantity = (e, i) => {
        if (e.target.value) {
            const [, dec = ""] = String(e.target.value).split(".");
            if (dec.length > 3) {
                toast.error("Upto 3 decimal places only");
                return;
            }
        }
        const obj = [...rows];
        let qt = Number(e.target.value);
        obj[i].quantity = qt;
        obj[i].amount = obj[i].rate * qt;

        obj[i].taxBean.amount1 = obj[i].amount * obj[i].taxBean.rate * 0.01;
        obj[i].taxBean.amount = obj[i].taxBean.amount1;

        setRows(obj);
        handleSubTotal(obj);
    };

    const handleRate = (e, i) => {
        if (e.target.value >= 1) {
            const obj = [...rows];
            obj[i].rate = Number(e.target.value);
            obj[i].amount = obj[i].quantity * Number(e.target.value);
            obj[i].taxBean.amount1 = obj[i].amount * obj[i].taxBean.rate * 0.01;
            obj[i].taxBean.amount = obj[i].taxBean.amount1;

            setRows(obj);
            handleSubTotal(obj);
        }
    };

    const handleShipCharge = (e) => {
        let ShipCharge = Number(e.target.value);
        let netShip = ShipCharge + ShipCharge * salesInfo?.shipTax?.rate * 0.01;
        let netTotal = Number(salesInfo.subTotal) + netShip + salesInfo.netTax;

        let tcsAmt = 0;
        tcsAmt = netTotal * defaultTcs.tcsRate / 100;

        setDefaultTcs((prev) => ({
            ...prev,
            tcsRateAmount: tcsAmt
        }))
        if (salesInfo.isTcsApplied) {
            netTotal = netTotal + tcsAmt;
        } else {
            tcsAmt = 0;
        }

        setSalesInfo({
            ...salesInfo,
            netShip: netShip,
            shipCharge: ShipCharge,
            tcsRateAmount: tcsAmt,
            total: netTotal,
        });
    };
    const handleShipTax = (e) => {
        let netShip = salesInfo.shipCharge + salesInfo.shipCharge * e.rate * 0.01;
        let netTotal = Number(salesInfo.subTotal) + netShip + salesInfo.netTax;

        let tcsAmt = 0;
        tcsAmt = netTotal * defaultTcs.tcsRate / 100;

        setDefaultTcs((prev) => ({
            ...prev,
            tcsRateAmount: tcsAmt
        }))

        if (salesInfo.isTcsApplied) {
            netTotal = netTotal + tcsAmt;
        } else {
            tcsAmt = 0;
        }

        setSalesInfo({
            ...salesInfo,
            shipTax: e,
            netShip: netShip,
            tcsRateAmount: tcsAmt,
            total: netTotal,
        });
    };

    const handleSave = (e) => {
        let validateQuantity = rows.filter((e) => {
            let quantity = e?.quantity;
            let selectedQuantity = e.beanStockTransferBatchList.reduce((acc, item) => acc + parseInt(item.batchQuantitySelected), 0);
            return selectedQuantity > quantity;
        });
        if (validateQuantity.length > 0) {
            toast.error(`Selected Quantity cannot item quantity ${validateQuantity[0].item?.label}`);
            return;
        }
        if (salesInfo.customer === "") {
            toast("Select customer");
            return;
        }
        if (salesInfo.salesPerson === "") {
            toast("Select salesPerson");
            return;
        }
        if (salesInfo.warehouse === "") {
            toast("Select warehouse");
            return;
        }
        if (salesInfo.terms === "") {
            toast("Select terms");
            return;
        }

        setLoading(true);

        rows?.map((a) => {
            if (id) {
                a.deleted = false;
            }
        });

        let rows2 = rows.filter((a) => a.item.value !== "");
        if (rows2.length === 0) {
            toast("Select item");
            setLoading(false);
            return;
        }
        if ((directInvoice || invoiceId) && !salesInfo.motorVehicleNo) {
            toast("Select Vehicle No.");
            setLoading(false);
            return;
        }

        let netTot = Number(salesInfo?.total).toFixed(2);
        let t2 = netTot.toString()?.split(".")[1];
        let rounding;
        if (t2 > 49) {
            netTot = Number(salesInfo?.total).toFixed(0);
            let a = 100 - t2;
            rounding = "0." + a;
        } else {
            rounding = "-0." + t2;
            netTot = netTot.toString()?.split(".")[0];
        }

        let sub1 = 0;
        rows2?.map((a) => {
            sub1 = sub1 + a.amount;
        });

        if (Number(sub1).toFixed(2) !== Number(salesInfo?.subTotal).toFixed(2)) {
            toast.error("subtotal mismatch");
            return;
        }
        let salesRequest = {
            totalAmount: netTot,
            roundOffAmount: Number(rounding),
            taxType: salesInfo.taxType === "Inter" ? "IGST" : "GST",
            roundOffTitle: "Round off to nearest zero",
            roundOffId: 1,
            isTcsApplied: salesInfo.isTcsApplied,
            tcsRate: parseFloat(defaultTcs.tcsRate),
            tcsRateAmount: parseFloat(defaultTcs.tcsRateAmount.toFixed(2)),
            totalTax: Number(salesInfo?.netTax).toFixed(2),
            isConfirmed: invoiceId || directInvoice ? true : false,
            items: rows2,
            customerId: salesInfo.customer.recordId,
            customerTitle: salesInfo.customer.title,
            customerMobileNumber: salesInfo?.customer?.phone,

            customerNote: salesInfo.notes,
            expectedShipmentDate: salesInfo.shipDate,
            salesOrderDate: salesInfo.orderDate,

            paymentTermsId: salesInfo.customer.paymentTermRecordId,
            paymentTermsTitle: salesInfo.customer.paymentTermTitle,

            priceListId: salesInfo.customer.itemPriceListRecordId,
            priceListTitle: salesInfo.customer.itemPriceListTitle,

            subTotalAmount: Number(salesInfo?.subTotal).toFixed(2),
            termsCondition: salesInfo.terms.label,
            termsConditionId: salesInfo.terms.value,

            warehouseId: salesInfo.warehouse.value,
            warehouseTitle: salesInfo.warehouse.label,
            referenceNo: salesInfo.reference,

            salespersonId: salesInfo.salesPerson.value,
            salespersonTitle: salesInfo.salesPerson.label,
            shippingCharges: salesInfo?.netShip,
            shippingHsnId: "68b893aa-ab89-40eb-b404-4f9b87fba8cd",
            shippingHsnSac: "996511",
            shippingChargeTaxRate: salesInfo?.shipTax?.rate,
            shippingChargeTaxId: salesInfo?.shipTax?.value,
            shippingChargeTaxTitle: salesInfo?.shipTax?.label,

            orderNo: "SO",
            salesOrderStatusEnum: "Confirmed",
            isDelivered: false,
            isPacked: false,
            isPaid: false,
            isShipped: false,
            discountTypeEnum: salesInfo?.customer?.discountType ? salesInfo?.customer?.discountType : "None",
            discountValue: salesInfo?.customer?.discountValue ? salesInfo?.customer?.discountValue : 0,
            eWayBillTransactionEnum: salesInfo?.eWayBillTransactionEnum?.value,
            metaData: customFields.length > 0 ? JSON.stringify(customFields) : null
        };
        if (invoiceId) {
            salesRequest.isInvoiced = true;
            salesRequest.recordId = salesInfo.recordId;
            salesRequest.invoiceNo = "IN";
            salesRequest.orderNo = "SO";
            salesRequest.motorVehicleNo = salesInfo.motorVehicleNo;
            salesRequest.salesOrderNo = salesInfo?.orderNo;
            salesRequest.salesOrderId = salesInfo?.salesOrderId;
            salesRequest.invoiceDate = salesInfo?.invoiceDate;
            salesRequest.itemsList = rows2;
            salesRequest.shippingHsnSac = "996511";
        }

        if (directInvoice) {
            salesRequest.isInvoiced = true;
            salesRequest.motorVehicleNo = salesInfo.motorVehicleNo;
            salesRequest.invoiceDate = salesInfo?.invoiceDate;
            salesRequest.shippingHsnSac = "996511";
        }

        if (directInvoice || reInvoice) {
            addDirectInvoiceRecord1(salesRequest)
                .then((res) => {
                    if (res.errorCode === 0) {
                        navigate("/invoices");
                        handleToast(res);
                        setLoading(false);
                    } else if (res.errorCode === 21) {
                        const _res = JSON.parse(res.message)
                        setItemList(_res);
                        setShow(true);
                        setLoading(false);
                    }
                    else {
                        handleToast(res);
                        setLoading(false);
                    }
                })
                .catch(() => {
                    toast.error("server error");
                    setLoading(false);
                    return;
                });
        } else {
            if (invoiceId) {
                if (invoiceEdit && !reInvoice) {
                    updateInvoice(invoiceId, salesRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/invoices");
                                handleToast(res);
                                setLoading(false);
                            } else if (res.errorCode === 21) {
                                const _res = JSON.parse(res.message)
                                setItemList(_res);
                                setShow(true);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                } else {
                    addInvoice(salesRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/invoices");
                                handleToast(res);
                                setLoading(false);
                            } else if (res.errorCode === 21) {
                                const _res = JSON.parse(res.message)
                                setItemList(_res);
                                setShow(true);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                }
            } else {
                salesRequest.isInvoiced = false;
                if (id) {
                    updateSalesOrder(id, salesRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/salesorders");
                                handleToast(res);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                } else {
                    addSalesOrder(salesRequest)
                        .then((res) => {
                            if (res.errorCode === 0) {
                                navigate("/salesorders");
                                handleToast(res);
                                setLoading(false);
                            } else if (res.errorCode === 21) {
                                const _res = JSON.parse(res.responsePacket)
                                setItemList(_res);
                                setShow(true);
                                setLoading(false);
                            } else {
                                handleToast(res);
                                setLoading(false);
                            }
                        })
                        .catch(() => {
                            toast.error("server error");
                            setLoading(false);
                            return;
                        });
                }
            }
        }
    };

    const handleModalPrice = (e, i) => {
        const { value } = e.target;
        const index = itemList.findIndex((obj, j) => i === j);
        if (index !== -1) {
            const newData = [...itemList];
            newData[index] = { ...newData[index], "CustomerItemPrice": value };
            setItemList(newData);
        }
    }

    const handleTcsCheckBox = (e) => {
        const { checked } = e.target;
        let tcsAmt = 0;
        tcsAmt = salesInfo.total * (defaultTcs.tcsRate / 100);
        setDefaultTcs({
            ...defaultTcs,
            tcsRateAmount: tcsAmt
        })
        if (checked) {
            setSalesInfo({
                ...salesInfo,
                isTcsApplied: checked,
                tcsRate: defaultTcs.tcsRate,
                tcsRateAmount: tcsAmt,
                total: parseFloat(salesInfo.total) + tcsAmt,
            })
        } else {
            setSalesInfo({
                ...salesInfo,
                isTcsApplied: checked,
                tcsRate: 0,
                tcsRateAmount: 0,
                total: parseFloat(salesInfo.total) - defaultTcs.tcsRateAmount,
            })
        }
    }

    const handlePriceUpdate = () => {
        const dispatchArr = itemList.map((item) => ({
            // label: "",
            // priceListId: "",
            // sPrice: "",
            // value: "",
            itemId: item.itemId,
            priceListId: item.priceListId,
            itemPrice: item.CustomerItemPrice,
        }))
        const salesOrderItemsUpdate = {
            salesOrderItemsUpdate: dispatchArr
        }

        updateSalesOrderItemByPriceListUid(salesOrderItemsUpdate).then((res) => {
            if (res.errorCode === 0) {
                rows.forEach((item2) => {
                    itemList.forEach((item1) => {
                        if (item1.itemId === item2.itemUuid) {
                            item2.rate = parseFloat(item1.CustomerItemPrice);
                            item2.amount = parseFloat(item2.quantity * item1.CustomerItemPrice);
                            item2.taxBean.amount1 = parseFloat((item2.amount * item2.taxBean.rate) / 100)
                            item2.taxBean.amount = parseFloat((item2.amount * item2.taxBean.rate) / 100)
                        }
                    })
                })
                handleSubTotal(rows);
                toast(res.message);
            }
            setShow(false);

        })

        // updatePrice(itemList[0]?.priceListId, )
        // .then((res) => {
        //   if (res.errorCode === 0) {
        //     toast(res.message);
        //     navigate("/pricelists");
        //     setLoading(false)
        //   } else {
        //     toast(res.message);
        //     setLoading(false)
        //   }
        // })
        // .catch(() => {
        //   toast.error("server error");
        //   return;
        // });
    }
    const handleSubRow = (ind) => {
        const data = rows;
        const newData = data.map((d, i) => {
            if (i === ind) {
                return {
                    ...d, beanStockTransferBatchList: [...d.beanStockTransferBatchList, {
                        stockTransferId: '',
                        stockTransferNo: '',
                        batchQuantitySelected: '',
                        batchNumber: '',
                        batchManufacturingDate: null,
                        batchExpiredDate: null,
                        storeTitle: '',
                        rackTitle: '',
                        cellTitle: '',
                        palletTitle: '',
                        storeId: '',
                        rackId: '',
                        cellId: '',
                        palletId: '',
                        rackOptions: [],
                        cellOptions: [],
                        palleteOptions: [],
                        referenceTitle: ""
                    }]
                }
            }
            else return d;
        })
        setRows(newData)

    }
    const handleSubRowRemove = (ind, j) => {
        const _rows = [...rows];
        const requiredRow = _rows[ind];
        requiredRow.beanStockTransferBatchList = requiredRow.beanStockTransferBatchList.filter((_, index) => index !== j);;
        setRows(_rows);
    }

    const handleSubRowchanges = (i, j, e, name) => {
        const _rows = [...rows];
        const requiredRow = _rows[i];

        if (name == "batchQuantitySelected") {
            if (e > requiredRow.beanStockTransferBatchList[j].batchQuantity) {
                toast.error("Batch quantity selected should not be greater than ");
                return;
            }
            requiredRow.beanStockTransferBatchList[j] = { ...requiredRow.beanStockTransferBatchList[j], batchQuantitySelected: e }
        }
        if (name == "batchNumber") {
            requiredRow.beanStockTransferBatchList[j] = { ...e, batchQuantitySelected: "", batchNumber: e.batchNumber, batchValue: `${e.batchNumber}-${e.count}` }
        }
        setRows(_rows);
    }

    return (
        <>
            {salesInfo && salesInfo ? (
                <>
                    <div className="fill list-header d-flex justify-content-between align-items-center bg-white p-3 border-bottom">
                        <h3 className="float-left">
                            <ArticleIcon />
                            &nbsp;&nbsp;
                            {title}
                            &nbsp;&nbsp;{salesInfo?.orderNo}&nbsp;&nbsp;{salesInfo?.invoiceNo}
                        </h3>
                    </div>

                    <div className="scroll-y noscroll-x fill body scrollbox" style={{ marginLeft: "15px" }}>
                        <div className="item-creation" autoComplete="off">
                            <div className="primary-info white-bg">
                                <div className="item-new">
                                    <div className="row">
                                        <div className="col-lg-8">
                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">Customer</label>

                                                <div className="col-lg-5">
                                                    <Select onChange={(e) => handleCustomer(e)} options={customerOptions} value={salesInfo.customer} />
                                                </div>
                                            </div>

                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">Warehouse</label>
                                                <div className="col-lg-5">
                                                    <Select isDisabled={salesInfo.customer ? false : true} onChange={(e) => handleWarehouse(e)} options={wareOptions} value={salesInfo.warehouse} />
                                                </div>
                                            </div>
                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">{invoiceId || directInvoice ? "Invoice Date" : "Order Date"}</label>
                                                <div className="col-lg-5">
                                                    {invoiceId || directInvoice ? (
                                                        <input
                                                            autoComplete="off"
                                                            className="form-control"
                                                            type="date"
                                                            name="invoiceDate"
                                                            onChange={(e) => handleData(e)}
                                                            value={salesInfo.invoiceDate}
                                                        />
                                                    ) : (
                                                        <input autoComplete="off" className="form-control" type="date" name="orderDate" onChange={(e) => handleData(e)} value={salesInfo.orderDate} />
                                                    )}
                                                </div>
                                            </div>
                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">Shipment Date</label>
                                                <div className="col-lg-5">
                                                    <input autoComplete="off" className="form-control" type="date" name="shipDate" onChange={(e) => handleData(e)} value={salesInfo.shipDate} />
                                                </div>
                                            </div>

                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">SalesPerson</label>
                                                <div className="col-lg-5">
                                                    <Select
                                                        onChange={(e) =>
                                                            setSalesInfo({
                                                                ...salesInfo,
                                                                salesPerson: e,
                                                            })
                                                        }
                                                        value={salesInfo.salesPerson}
                                                        options={salesPerOptions}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">E-Way Bill Transaction Type</label>
                                                <div className="col-lg-5">
                                                    <Select
                                                        onChange={(e) =>
                                                            setSalesInfo({
                                                                ...salesInfo,
                                                                eWayBillTransactionEnum: e,
                                                            })
                                                        }
                                                        value={salesInfo.eWayBillTransactionEnum}
                                                        options={eWayBillOptionsObj}
                                                    />
                                                </div>
                                            </div>

                                            <div className="row form-group">
                                                <label className="col-lg-3 col-form-label required">Terms</label>

                                                <div className="col-lg-5">
                                                    <Select onChange={(e) => handleTerms(e)} options={termsOptions} value={salesInfo.terms} />
                                                </div>
                                            </div>
                                            {directInvoice || invoiceId ? (
                                                <div className="row form-group">
                                                    <label className="col-lg-3 col-form-label required ">Vehicle No.</label>
                                                    <div className="col-lg-5">
                                                        <input autoComplete="off" className="form-control" name="motorVehicleNo" onChange={(e) => handleData(e)} value={salesInfo.motorVehicleNo} />
                                                    </div>
                                                </div>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                        <div>
                                            {salesInfo?.customer ? (
                                                <table>
                                                    <tr>
                                                        <td style={{ minWidth: "100px" }}>Billing:</td>
                                                        <td>{salesInfo?.customer?.billAdd?.state}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Shipping</td>
                                                        <td>{salesInfo?.customer?.shipAdd?.state}</td>
                                                    </tr>
                                                    <tr>
                                                        <td>PriceList:</td>
                                                        {salesInfo?.customer?.itemPriceListTitle}
                                                    </tr>
                                                    <tr>
                                                        <td>Pay Terms:</td>
                                                        <td>{salesInfo?.customer?.paymentTermTitle}</td>
                                                    </tr>
                                                </table>
                                            ) : (
                                                <></>
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <br />
                                <hr />

                                {/* Custom Metadata Fields */}
                                <div style={{ marginBottom: "15px" }}>
                                    <div style={{ display: "flex", alignItems: "center", marginBottom: "10px" }}>
                                        <strong>Custom Fields</strong>
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary"
                                            style={{ marginLeft: "10px" }}
                                            onClick={handleAddCustomField}
                                        >
                                            <AddIcon fontSize="small" /> Add Field
                                        </button>
                                    </div>
                                    {customFields.map((cf, idx) => (
                                        <div key={idx} className="row form-group" style={{ marginBottom: "5px" }}>
                                            <div className="col-lg-3">
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Label"
                                                    value={cf.label}
                                                    onChange={(e) => handleCustomFieldChange(idx, "label", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-4">
                                                <input
                                                    autoComplete="off"
                                                    className="form-control"
                                                    placeholder="Value"
                                                    value={cf.value}
                                                    onChange={(e) => handleCustomFieldChange(idx, "value", e.target.value)}
                                                />
                                            </div>
                                            <div className="col-lg-1">
                                                <span
                                                    style={{ cursor: "pointer", color: "red", fontSize: "18px" }}
                                                    onClick={() => handleRemoveCustomField(idx)}
                                                >
                                                    <i className="fa fa-times"></i>
                                                </span>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <div className="customTable">
                                    <table style={{ width: "100%" }}>
                                        <tr>
                                            <td></td>
                                            <td>Sno.</td>
                                            <td style={{ minWidth: "100px" }}>Item</td>
                                            <td>Stock</td>
                                            <td>Qty</td>
                                            <td>Rate</td>
                                            <td>Tax</td>
                                            <td>TaxAmt</td>

                                            <td>Amount</td>
                                            <td></td>
                                        </tr>
                                        {rows &&
                                            rows?.map((data, itemIndex) => {
                                                return (
                                                    <Fragment key={itemIndex}>
                                                        <tr style={{ borderBottom: "0" }} >
                                                            <td>
                                                                <div className={itemLoading ? "spinner-loader" : ""}></div>
                                                            </td>
                                                            <td style={{ width: "50px" }}>{itemIndex + 1}</td>
                                                            <td style={{ minWidth: "250px" }}>
                                                                <Select
                                                                    isDisabled={(itemOptions ? false : true) || itemLoading}
                                                                    style={{ zIndex: "20" }}
                                                                    placeholder="Item"
                                                                    options={itemOptions}
                                                                    value={data.item}
                                                                    onChange={(e) => handleItem(e, itemIndex)}
                                                                />
                                                            </td>
                                                            <td style={{ color: data?.stock <= 0 ? "red" : "" }}>{data?.stock}</td>
                                                            <td>
                                                                <input autoComplete="off" type="number" min={1} value={data.quantity} onChange={(e) => handlequantity(e, itemIndex)} />
                                                                &nbsp;{data?.unit}
                                                            </td>
                                                            <td>{data.rate}</td>
                                                            {/* <td><input autoComplete="off" type="number" min={1} value={data.rate} onChange={(e) => handleRate(e, i)} /></td> */}
                                                            <td>{data.taxBean?.title}</td>
                                                            <td>{data.taxBean?.amount?.toFixed(2)}</td>
                                                            <td>{data.amount?.toFixed(2)}</td>
                                                            <td style={{ cursor: "pointer" }} onClick={() => handleClear(data.item.value, itemIndex)}>
                                                                <i className="fa fa-times"></i>
                                                            </td>
                                                        </tr>
                                                        <div style={{ height: "10px" }}></div>
                                                        <tr key={itemIndex} >
                                                            <td colSpan={24}>
                                                                <table style={{ width: "100%" }}>
                                                                    <tr style={{ borderTop: "1px solid #efefef" }} >
                                                                        <td> Batch </td>
                                                                        <td style={{ padding: 0 }}> Batch Qty</td>
                                                                        <td> Qty </td>
                                                                        {/* <td> Rate </td> */}
                                                                        <td> Mfg </td>
                                                                        <td> Expiry </td>
                                                                        <td>Store</td>
                                                                        <td>Rack</td>
                                                                        <td>Cell</td>
                                                                        <td>Pallete</td>
                                                                        <td className="text-right" style={{ padding: 0, width: "100px" }}>
                                                                            {!(((itemIndex, disableWhileEditing?.[itemIndex]) != undefined) && invoiceEdit) &&
                                                                                <button
                                                                                    disabled={itemLoading}
                                                                                    id="ember1426"
                                                                                    className="btn btn-default addbtn"
                                                                                    onClick={() => handleSubRow(itemIndex)}
                                                                                >
                                                                                    <AddIcon
                                                                                        style={{ color: "blue", }}
                                                                                    />{" "}
                                                                                    Add
                                                                                    More
                                                                                </button>}
                                                                        </td>
                                                                    </tr>
                                                                    {data?.beanStockTransferBatchList && data?.beanStockTransferBatchList.map((billBatch, j) => {
                                                                        const batchOptions = data?.beanInvoiceBatchesList.filter((e) => !(data.beanStockTransferBatchList.find((d) => (`${d?.batchNumber}-${d?.count}` == `${e?.batchNumber}-${e?.count}`))))
                                                                        const last = data.beanStockTransferBatchList.length === j + 1
                                                                        return <tbody>
                                                                            <tr style={{ borderBottom: last && `0` }} key={j}>
                                                                                <td style={{ width: "30%" }} >
                                                                                    <Select
                                                                                        isDisabled={(itemLoading || (itemIndex, disableWhileEditing?.[itemIndex]?.beanStockTransferBatchList.length) != undefined) && invoiceEdit}
                                                                                        styles={{
                                                                                            control: (base) => ({
                                                                                                ...base,
                                                                                                minWidth: '80px',
                                                                                            }),
                                                                                            menu: (base) => ({
                                                                                                ...base,
                                                                                                minWidth: '80px',
                                                                                            }),
                                                                                        }}
                                                                                        name="batchNumber"
                                                                                        onChange={(e) => handleSubRowchanges(itemIndex, j, e, "batchNumber")}
                                                                                        value={{
                                                                                            value: billBatch?.batchValue,
                                                                                            label: billBatch?.batchNumber
                                                                                        }}
                                                                                        options={batchOptions && batchOptions?.length > 0
                                                                                            ? batchOptions.map(e => ({
                                                                                                ...e,
                                                                                                value: `${e?.batchNumber}-${e?.count}`,
                                                                                                label: e.batchNumber
                                                                                            }))
                                                                                            : []
                                                                                        }
                                                                                    />

                                                                                </td>
                                                                                <td style={{ width: "20%" }} >{billBatch?.batchQuantity}</td>
                                                                                <td>
                                                                                    <input
                                                                                        disabled={itemLoading}
                                                                                        value={billBatch?.batchQuantitySelected}
                                                                                        type="text"
                                                                                        name="batchQuantitySelected"
                                                                                        onChange={(e) => handleSubRowchanges(itemIndex, j, e.target.value, "batchQuantitySelected", billBatch.batchQuantity)}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        value={billBatch?.batchManufacturingDate}
                                                                                        type="date"
                                                                                        name="batchManufacturingDate"
                                                                                        disabled={true}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <input
                                                                                        value={billBatch?.batchExpiredDate}
                                                                                        type="date"
                                                                                        name="batchExpiredDate"
                                                                                        disabled={true}
                                                                                    />
                                                                                </td>
                                                                                <td>
                                                                                    <Input disabled={true} value={billBatch?.storeTitle}></Input>
                                                                                </td>
                                                                                <td >
                                                                                    <Input disabled={true} value={billBatch?.rackTitle}></Input>
                                                                                </td>
                                                                                <td>
                                                                                    <Input disabled={true} value={billBatch?.cellTitle}></Input>
                                                                                </td>
                                                                                <td >
                                                                                    <Input disabled={true} value={billBatch?.palletTitle}></Input>
                                                                                </td>
                                                                                <td style={{ width: "20%" }} className="text-right">
                                                                                    {!(((itemIndex, disableWhileEditing?.[itemIndex]?.beanStockTransferBatchList.length) != undefined) && invoiceEdit) && <button
                                                                                        disabled={itemLoading}
                                                                                        className="btn btn-default addbtn"
                                                                                        onClick={() => handleSubRowRemove(itemIndex, j)}
                                                                                    >
                                                                                        X
                                                                                    </button>}
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    }
                                                                    )}
                                                                </table>
                                                            </td>
                                                        </tr>
                                                    </Fragment>

                                                );
                                            })}
                                    </table>
                                </div>

                                <button id="ember1426" className="btn btn-default addbtn mt-3" onClick={handleAddNewRow}>
                                    <AddIcon style={{ color: "blue" }} /> New Row
                                </button>

                                <br />
                                <br />
                                <div className="row" style={{ justifyContent: "space-between" }}>
                                    <table className="customTable">
                                        <tr>
                                            <td>Notes</td>
                                            <td>
                                                {" "}
                                                <textarea className="form-control" name="notes" onChange={(e) => handleData(e)} value={salesInfo.notes} />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Reference</td>
                                            <td>
                                                {" "}
                                                <input autoComplete="off" className="form-control" name="reference" onChange={(e) => handleData(e)} value={salesInfo.reference} />
                                            </td>
                                        </tr>
                                    </table>

                                    <table className="customTable" style={{ paddingRight: "20px", textAlign: "right" }}>
                                        <tr>
                                            <td>Subtotal</td>
                                            <td></td>
                                            <td></td>
                                            <td>{Number(salesInfo?.subTotal).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Shipping [HSN: 996511]:</td>
                                            <td>
                                                <input autoComplete="off" type="number" value={salesInfo.shipCharge} onChange={(e) => handleShipCharge(e)} />
                                            </td>
                                            <td>
                                                <Select onChange={(e) => handleShipTax(e)} options={taxOptions} value={salesInfo.shipTax} />
                                            </td>
                                            <td>{Number(salesInfo?.netShip).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Total Tax</td>
                                            <td></td>
                                            <td></td>
                                            <td>{Number(salesInfo?.netTax).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>TCS</td>
                                            <td className="text-center"><input type="checkbox" name="" id="" onChange={handleTcsCheckBox} checked={salesInfo.isTcsApplied} /></td>
                                            <td>{Number(salesInfo.tcsRate).toFixed(2)}</td>
                                            <td>{Number(salesInfo.tcsRateAmount).toFixed(2)}</td>
                                        </tr>
                                        <tr>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td>{Number(salesInfo?.total).toFixed(2)}</td>
                                        </tr>
                                    </table>
                                </div>

                                <div className="text-left mt-3 mb-4">
                                    {loading ? (
                                        <Button variant="contained">
                                            <Spinner />
                                        </Button>
                                    ) : (
                                        fssaiWarningStatus?.status !== 'EXPIRED' && <Button variant="contained" onClick={handleSave}>
                                            Save
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                "loading.."
            )}

            <Modal show={show} onHide={() => setShow(false)} size="xl">
                <div className="d-flex justify-content-between mt-3 mx-4">
                    <h3 className="font-size-20">Update</h3>
                </div>
                <Modal.Body>
                    <div className="custom-table-div standardTable" id="pdf" style={{ width: "100%", margin: "15px", color: "black" }}>
                        <div className="row p-3 align-items-center">
                            <div className="col-5">
                                <h2 className="font-size-18 font-weight-bold">{itemList[0]?.priceListTitle}</h2>
                            </div>
                        </div>
                        <hr style={{ backgroundColor: "#ececec" }} />
                        <div>
                            {itemList?.length > 0 ? (
                                <>
                                    <table className=" table">
                                        <thead>
                                            <tr>
                                                <th>SNO.</th>
                                                <th>Item Title</th>
                                                <th>Purchase Price</th>
                                                <th>Selling Price</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {itemList.map((a, i) => (
                                                <tr key={i}>
                                                    <td>{i + 1}</td>
                                                    <td>{a.itemTitle}</td>
                                                    <td>{a.ItemPrice}</td>
                                                    <td><input autoComplete="off" className="form-control" name="reference" value={a.CustomerItemPrice} onChange={(e) => handleModalPrice(e, i)} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </>

                            ) : (
                                <>No Record found</>
                            )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="contained" onClick={handlePriceUpdate}>
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>

            <Toaster />

            {/* FSSAI Due Warning Modal */}
            <Modal show={showFssaiModal && fssaiWarningStatus?.status === "DUE"} onHide={() => {setShowFssaiModal(false); setFssaiWarningStatus(null);}} centered size="sm">
                <Modal.Header style={{ borderBottom: "2px solid #ffc107", padding: "12px 16px" }}>
                    <Modal.Title style={{ fontSize: "15px", fontWeight: "600", color: "#856404", display: "flex", alignItems: "center", gap: "8px" }}>
                        <i className="fa fa-exclamation-triangle" style={{ color: "#ffc107" }}></i>
                        &nbsp;FSSAI Expiry Warning
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "16px", textAlign: "center" }}>
                    <div style={{ color: "#856404", fontSize: "13px", lineHeight: "1.6" }}>
                        <p style={{ margin: 0 }}>
                            This customer's <strong>FSSAI license</strong> is expiring on {fssaiWarningStatus?.date}.
                            Please ensure it is renewed before proceeding.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: "1px solid #ececec", padding: "8px 16px", justifyContent: "center" }}>
                    <Button variant="contained" size="small" style={{ backgroundColor: "#ffc107", color: "#212529", boxShadow: "none", textTransform: "none", fontSize: "13px" }} onClick={() => setShowFssaiModal(false)}>
                        Acknowledge
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* FSSAI Expired Warning Modal */}
            <Modal show={showFssaiModal && fssaiWarningStatus?.status === "EXPIRED"} onHide={() => {setShowFssaiModal(false); setFssaiWarningStatus(null);}} centered size="sm">
                <Modal.Header style={{ borderBottom: "2px solid #dc3545", padding: "12px 16px" }}>
                    <Modal.Title style={{ fontSize: "15px", fontWeight: "600", color: "#721c24", display: "flex", alignItems: "center", gap: "8px" }}>
                        <i className="fa fa-times-circle" style={{ color: "#dc3545" }}></i>
                        &nbsp;FSSAI License Expired
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ padding: "16px", textAlign: "center" }}>
                    <div style={{ color: "#721c24", fontSize: "13px", lineHeight: "1.6" }}>
                        <p style={{ margin: 0 }}>
                            This customer's <strong>FSSAI license has expired</strong>.
                            Proceeding without a valid license may not be permissible.
                        </p>
                    </div>
                </Modal.Body>
                <Modal.Footer style={{ borderTop: "1px solid #ececec", padding: "8px 16px", justifyContent: "center" }}>
                    <Button variant="contained" size="small" style={{ backgroundColor: "#dc3545", color: "#fff", boxShadow: "none", textTransform: "none", fontSize: "13px" }} onClick={() => setShowFssaiModal(false)}>
                        Acknowledge
                    </Button>
                </Modal.Footer>
            </Modal>

        </>
    );
};

export default InvoiceNew;
